import React from 'react';
import { useParams } from 'react-router-dom';
import RoleFormPage from './RoleFormPage';

const RoleEditPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  return <RoleFormPage mode="edit" roleId={id} />;
};

export default RoleEditPage;
